import React from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import { getRoutesForPermissionCode } from 'helpers/permissionHelper';
const columns = [
  {
    accessor: 'code',
    Header: 'Code'
  },
  {
    accessor: 'name',
    Header: 'Name'
  },
  {
    accessor: 'description',
    Header: 'Description'
  },
  {
    accessor: 'routes',
    Header: 'Route(s)',
    Cell: rowData => {
      const { code, name } = rowData.row.original;
      const routes = getRoutesForPermissionCode(code, name);
      if (routes.length === 0) return <span className="text-muted">—</span>;
      return (
        <div>
          {routes.map(r => (
            <div key={r.path}>
              {r.name} <span className="text-muted">({r.path})</span>
            </div>
          ))}
        </div>
      );
    }
  },
  {
    accessor: 'action',
    Header: 'Action',
    Cell: () => <span className="text-primary">Edit</span>
  }
];

const PermissionSetupTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  onPageSizeChange,
  handleClickRow
}) => {
  return (
    <PartialTable
      data={data}
      columns={columns}
      paging={paging}
      total={total}
      nextPage={nextPage}
      previousPage={previousPage}
      gotoPage={gotoPage}
      onPageSizeChange={onPageSizeChange}
      handleClickRow={handleClickRow}
    />
  );
};

PermissionSetupTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func
};

export default PermissionSetupTable;
